import styled from "styled-components";

const Main = styled.main`
  max-width: ${(props) => props.theme.pageWidth};
  margin: 0 auto;
  margin-bottom: 80px;
`;

export { Main };
